export default __webpack_public_path__ + "static/media/Rubik-BlackItalic.447fb288.ttf";